import React from "react";
import { IoCarOutline, IoLocationOutline } from "react-icons/io5";
import { CiCalendarDate } from "react-icons/ci";

function EasyBookingProcess() {
  const steps = [
    {
      title: "CHOOSE YOUR DESTINATION",
      desc: "Choose pickup and destined location.",
      icon: (
        <IoLocationOutline className="text-[#edebec] text-5xl sm:text-6xl md:text-7xl" />
      ),
    },
    
    {
      title: "CHOOSE YOUR DATE",
      desc: "Choose your pickup date and time.",
      icon: (
        <CiCalendarDate className="text-[#edebec] text-5xl sm:text-6xl md:text-7xl" />
      ),
    },
    {
      title: "SELECT YOUR VEHICLE",
      desc: "Find the perfect car for your trip.",
      icon: (
        <IoCarOutline className="text-[#edebec] text-5xl sm:text-6xl md:text-7xl" />
      ),
    },
  ];

  return (
    <div className="flex flex-col items-center justify-center bg-[#edebec] pt-32 pb-6 -mt-[6rem] m-12">
      <div className="flex justify-center ">
        <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-4xl text-center text-[#006039] font-semibold mb-4 pb-2 border-b-2 border-[#ca8032] inline-block">
          Easy Booking Process
        </h1>
      </div>

      <p className="text-md text-center text-[#353535] font-semibold mb-12">
        Simple 3-Step Booking Process
      </p>

      <div className="flex flex-col md:flex-row items-center justify-center">
        {steps.map((item, idx) => (
          <React.Fragment key={idx}>
            {/* Step Box */}
            <div className="flex flex-col items-center text-center z-10">
              <div className="w-20 h-20 sm:w-24 sm:h-24 md:w-32 md:h-32 bg-[#006039] text-[#edebec] rounded-lg shadow-md flex items-center justify-center mb-4">
                {item.icon}
              </div>
              <div className="text-[#353535] text-sm sm:text-md md:text-md font-semibold">
                <p>{item.title}</p>
              </div>
              <div className="text-[#353535] text-xs sm:text-sm md:text-sm font-light">
                <p>{item.desc}</p>
              </div>
            </div>

            {/* Connector: Horizontal (desktop) */}
            {idx < steps.length - 1 && (
              <div className="hidden md:flex items-center justify-center">
                <svg
                  width="80" // smaller on smaller screens
                  height="32"
                  viewBox="0 0 160 64"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0 32 Q40 0 80 32 T160 32"
                    stroke="#ca8032"
                    strokeWidth="6"
                    strokeDasharray="5,5"
                    fill="none"
                  />
                </svg>
              </div>
            )}

            {/* Connector: Vertical (mobile) */}
            {idx < steps.length - 1 && (
              <div className="md:hidden my-2">
                <svg
                  width="32"
                  height="80"
                  viewBox="0 0 64 160"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M32 0 Q0 40 32 80 T32 160"
                    stroke="#ca8032"
                    strokeWidth="2"
                    strokeDasharray="5,5"
                    fill="none"
                  />
                </svg>
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}

export default EasyBookingProcess;
